import {useRef, useState, useEffect} from "react";
import {debounce} from "@/app/utils/event";
import Button from "../Button/button";

type SmsCodeProps = {
    initialSeconds?: number;
    buttonText?: string;
    disabledText?: string;
    onIsGetCode?: () => Promise<boolean>;
    disabled?: boolean;
}

const SmsCode: React.FC<SmsCodeProps> = (props) => {
    const {
        initialSeconds = 60,
        buttonText = 'Send Code',
        disabledText = '${seconds}s',
        onIsGetCode = () => Promise<false>,
        disabled = false,
    } = props;

    const [seconds, setSeconds] = useState(initialSeconds);
    const [isCounting, setIsCounting] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | number | null>(null);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        }
    }, [])

    const startCountdown = () => {
        setIsCounting(true);
        setSeconds(initialSeconds);

        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        timerRef.current = setInterval(() => {
            setSeconds(prevState => {
                if (prevState === 1) {
                    timerRef.current && clearInterval(timerRef.current);
                    setIsCounting(false);
                    return initialSeconds;
                }
                return prevState - 1;
            })
        }, 1000);
    }

    const handleGetSmsCode = async () => {
        const result = await onIsGetCode();
        result && !isCounting && startCountdown();
    }

    return (
        <Button
            style={{
                width: '2.6rem',
                boxSizing: 'content-box',
                color: '#fff'
            }}
            color={disabled ? "#0090FF" : "#ccc" }
            size="small"
            disabled={isCounting}
            onClick={debounce(handleGetSmsCode, 100)}
        >
            {isCounting ? disabledText.replace('${seconds}', seconds.toString()) : buttonText}
        </Button>
    )
}

export default SmsCode;